import Img2 from "../assets/images/little-girl.png";
import Img1 from "../assets/images/blog-img1.png";
import Img3 from "../assets/images/lms.png";
import Img4 from "../assets/images/teachers-guide.png";
import Img5 from "../assets/images/blog-dashboard2.png";
import Img7 from "../assets/images/edu-trends.png";
import Img6 from "../assets/images/office-view.png";
import Avi from "../assets/images/spin-bg.png";

export const blogPostColOne = [
  {
    title:
      "We Must Equip Teachers With The Skills And Knowledge They Need To Be Confident And Effective Users Of Technology",
    paragraph:
      "Every year we are seeing a change of trends in almost all sectors and the case is no different in the field of education. This is one of the are…",
    img: Img1,
    date: "11th June, 2021",
    blog_id: 1,
  },
  {
    title:
      "Using educare LMS To Keep Up With The Pace Of Growth And Student Demand",
    paragraph:
      "Challenge An LMS to facilitate online learning to handle rapid school growth and changing needs Products & Solutions educ…",
    img: Img3,
    blog_id: 2,
    date: "12th June, 2021",
  },
  {
    title: "Teachers Guide On How To Set CBT Questions",
    paragraph:
      "Follow the steps below to set up questions for your exam; STEP 1: As indicated in the picture below, click on the “CBT” dropdow…",
    img: Img4,
    blog_id: 3,
    date: "12th June, 2021",
  },
  {
    title: "Human Resource Management (HRM)",
    paragraph:
      "We’re excited to announce the latest feature on our educare e-portal. That is the educare Human Resources Manager (HRM) Feature. It aims to har…",
    img: Img5,
    blog_id: 4,
    date: "12th June, 2021",
  },

  {
    title:
      "K-12: What Are The Pedagogical Advantages Of Online Learning, Compared To In-person Classroom Learning?",
    paragraph:
      "“Online learning can be as good or even better than in-person classroom learning. Research has shown that students in online lear…",
    img: Img2,
    blog_id: 5,
    date: "12th June, 2021",
  },
  {
    title:
      "Why Schools Should Consider Adopting A Data-Driven Culture Now More Than Ever",
    paragraph:
      "Start with data-driven decision making. I heard it all the time when I was an undergrad: Be a “data-driven decision maker.” No matter ho…",
    img: Img6,
    blog_id: 6,
    date: "12th June, 2021",
  },
  {
    title: "Top 24 Educational Trends For 2020",
    paragraph:
      "Every year we are seeing a change of trends in almost all sectors and the case is no different in the field of education. This is one of the areas we s…",
    img: Img7,
    blog_id: 7,
    date: "12th June, 2021",
  },
];

export const blogPostHead = [
  {
    title:
      "We Must Equip Teachers With The Skills And Knowledge They Need To Be Confident And Effective Users Of Technology",
    paragraph:
      "Every year we are seeing a change of trends in almost all sectors and the case is no different in the field of education. This is one of the are…",
    img: Img1,
    date: "12th June, 2021",
    blog_id: 1,
    avi: Avi,
    time: '6-mins read',
    author: 'Henry Okafor',
    role: 'Head of Support'

  },


];